import React from "react";
import CalendarDate from "./../widgets/calendar-date";

const CalendarItem = ({start_date, name, start_time, end_time, description, place}) => {
	return (<article className="calendar-item">
		<div className="date-details">
			<div className="date">
				<CalendarDate date={start_date} />
			</div>
			<div className="title">
				<h1>{name}</h1>
			</div>
			<div className="time">
				<p><span>Horario:</span> {start_time}hrs a {end_time}hrs</p>
			</div>
		</div>
		<div className="body">
			<div className="content description" dangerouslySetInnerHTML={{__html: description}} />
			<div className="place">
				<h3>{place.name}</h3>
				<div className="address">
					<p>
						{place.address} <br/>
						{place.address2} <br/>
						{place.zipcode} {place.city}, {place.state} <br/>
						{place.phone} <br/>
						{place.email}
					</p>
				</div>
			</div>
		</div>
	</article>)
}

export default CalendarItem;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/calendar/calendar-item.jsx